import React, { useState } from 'react';
import { css } from '@emotion/react';

export default function Accordion(props) {
  const [open, setOpen] = useState(props.open);

  return (
    <div
      className="type--small"
      css={css`
        border-bottom: 1px solid var(--black);
      `}
    >
      <div
        className="type--uppercase"
        css={css`
          font-weight: bold;
          text-align: center;
          padding: 1.5rem 0;
          cursor: pointer;
          user-select: none;

          @media (max-width: 700px) {
            font-size: 2.5rem;
          }
        `}
        role="button"
        aria-expanded={(open) ? true : false}
        tabIndex="0"
        onMouseDown={() => setOpen(!open)}
        onKeyPress={(e) => {
          e.persist();

          if (e.key === 'Enter')
            setOpen(!open);
        }}
      >{props.title}</div>
      <div
        css={css`
          display: ${(open) ? 'block' : 'none'};
          margin-top: -0.5rem;
          margin-bottom: 1.5rem;

          @media (max-width: 700px) {
            margin-top: 1rem;
            margin-bottom: 2.5rem;
          }
        `}
      >{props.children}</div>
    </div>
  )
}
